import {ErrorHandler} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CustomDatePipe} from './pipes/custom.date.pipe';
import {DateService} from './service/date.service';
import {Logger} from './logging/default-log.service';
import {LogService} from './logging/log.service';
import {SystemMonitorErrorHandler} from './logging/exception.handler';
import {HttpClient as NoviHttpClient} from './service/http.service';
import {DeliveryService} from './service/delivery.service';
import {UserService} from './service/user.service';
import {ApplicationService} from './service/application.service';
import {ShoppingCartService} from './service/shoppingcart.service';
import {WindowRef} from './service/window-ref.service';
import {NumberFormatPipe} from './pipes/number.format.pipe';
import {DatePipe, registerLocaleData} from '@angular/common';
import {FilterService} from './service/filter.service';
import {FavoriteService} from './service/favorite.service';
import {ProductService} from './service/product.service';
import {PricelistService} from './service/pricelist.service';
import {BarcodeScannerService} from './service/barcode.scanner.service';
import {PendingOrderService} from './service/pending.order.service';
import {PlanthunterService} from './service/planthunter.service';
import {TagManagerService} from './service/tag.manager.service';
import {RedirectService} from './service/redirect.service';
import {NotAuthorizedInterceptor} from './service/not-authorized-interceptor.service';
import {CookieService} from './service/cookie.service';
import {PlantscapingService} from './service/plantscaping.service';

import localeDA from '@angular/common/locales/da';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
import localeNL from '@angular/common/locales/nl';
import localePL from '@angular/common/locales/pl';
import localeSV from '@angular/common/locales/sv';
import localeFI from '@angular/common/locales/fi';
import localeSK from '@angular/common/locales/sk';
import localeNB from '@angular/common/locales/nb';
import localeFR from '@angular/common/locales/fr';

// Needed for the localization of the CustomDatePipe.
// See https://angular.io/api/common/registerLocaleData
// for more information.
registerLocaleData(localeDA);
registerLocaleData(localeDE);
registerLocaleData(localeEN);
registerLocaleData(localeNL);
registerLocaleData(localePL);
registerLocaleData(localeSV);
registerLocaleData(localeFI);
registerLocaleData(localeSK);
registerLocaleData(localeNB);
registerLocaleData(localeFR);

export const genericImports = [
	BrowserModule,
	HttpClientModule,
	NgSelectModule,
	FormsModule,
	ReactiveFormsModule,
	BrowserAnimationsModule,
	ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'})
];

export const genericDeclarations = [
	CustomDatePipe,
	NumberFormatPipe,
];

export const genericProviders = [
	DatePipe,
	DateService,
	NoviHttpClient,
	DeliveryService,
	UserService,
	ApplicationService,
	ShoppingCartService,
	FilterService,
	FavoriteService,
	ProductService,
	PricelistService,
	BarcodeScannerService,
	PendingOrderService,
	PlanthunterService,
	TagManagerService,
	CookieService,
	PlantscapingService,
	RedirectService,
	WindowRef,
	{
		provide: HTTP_INTERCEPTORS,
		useClass: NotAuthorizedInterceptor,
		multi: true
	},
	{provide: Logger, useClass: LogService},
	{provide: ErrorHandler, useClass: SystemMonitorErrorHandler}
];
